module.exports = "<status-widget widget-name=\"{{'dashboard.panel.policies.title'|translate}}\"\n               widget-state=\"app.policies\"\n               items=\"$ctrl.data\"\n               chart-colors=\"$ctrl.donutColors\"\n               donut-percentage=\"true\"\n               widget-title-tooltip=\"{{::'dashboard.panel.policies.descriptionTooltip'|translate}}\"\n               render-counter=\"$ctrl.renderCounter\"\n               cursor-pointer=\"true\">\n</status-widget>"


//////////////////
// WEBPACK FOOTER
// ./src/azurebackup/views/dashboard/components/policiesWidget/policiesWidget.template.html
// module id = 494
// module chunks = 0